import { c as _c } from "react/compiler-runtime";
import { ListItemMenu } from "@components/common/mobile/list-item-menu";
import { useProjectMenuOptions } from "@pages/projects/use-project-menu-options";
/**
 * 3-dot options menu for a project row, providing contextual actions such as
 * view details, open in viewer/HoloBuilder, management, access level,
 * archive/unarchive, share, and delete.
 */
export function ProjectOptionsMenu(t0) {
  const $ = _c(10);
  const {
    project,
    contextType,
    extraMenuItems: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const extraMenuItems = t2;
  let t3;
  if ($[2] !== contextType) {
    t3 = {
      contextType
    };
    $[2] = contextType;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const menuItems = useProjectMenuOptions(t3);
  let t4;
  if ($[4] !== extraMenuItems || $[5] !== menuItems) {
    t4 = [...menuItems, ...extraMenuItems];
    $[4] = extraMenuItems;
    $[5] = menuItems;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== project || $[8] !== t4) {
    t5 = <ListItemMenu item={project} menuItems={t4} />;
    $[7] = project;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}